import { render } from "./MyEVehicleDetail.vue?vue&type=template&id=062f648e&scoped=true"
import script from "./MyEVehicleDetail.vue?vue&type=script&lang=js"
export * from "./MyEVehicleDetail.vue?vue&type=script&lang=js"

import "./MyEVehicleDetail.vue?vue&type=style&index=0&id=062f648e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062f648e"]])

export default __exports__